<template>
  <div>
    <div class="misc-wrapper">
      <div class="misc-inner p-sm-3">
        <div class="w-100 text-center mt-1">
          <b-img class="w-25 mb-3"
                 fluid
                 :src="imgUrl"
                 alt="Not authorized page"/>
          <h2 class="mb-2">
            {{ $t('noSharedDocuments') }}
          </h2>
          <p class="mb-2">
            {{ $t('noSharedDocumentsDescription') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {BImg} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'

export default {
  name: "Empty",
  components: {
    BImg
  },
  props: {
    newDocumentUrl: {
      type: String,
      required: true,
    }
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      modalShow: false,
      emptyImg: require('@/assets/images/illustration/shared_documents.svg'),
    }
  },
  computed: {
    imgUrl() {
      return this.emptyImg
    },
  },
  methods: {
    openEditorScreen() {
      this.$router.replace(this.newDocumentUrl)
    },
    showModal() {
      this.$refs['cm'].$refs['modal'].show();
    }
  }
}
</script>

<style scoped>

</style>